export class Result {

    /** For debugging purposes */
    public resultType: string = "Result";

    public cashWon: number = 0;

    public linkedResult?: Result;
}
